import { lazy, Suspense, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import SEO from "@/components/SEO";

// Lazy load below-the-fold components
const MentorSection = lazy(() => import("@/components/MentorSection"));
const YouTubeSection = lazy(() => import("@/components/YouTubeSection"));
const Curriculum = lazy(() => import("@/components/Curriculum"));
const Pricing = lazy(() => import("@/components/Pricing"));
const CertificateClaim = lazy(() => import("@/components/CertificateClaim"));
const Testimonials = lazy(() => import("@/components/Testimonials"));
const Partners = lazy(() => import("@/components/Partners"));
const Footer = lazy(() => import("@/components/Footer"));
const StickyMobileCTA = lazy(() => import("@/components/StickyMobileCTA"));

const CTAStrip = lazy(() => import("@/components/CTAStrip"));

// Minimal loading placeholder
const SectionLoader = () => (
  <div className="min-h-[200px] flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
  </div>
);

const Index = () => {
  const location = useLocation();

  useEffect(() => {
    const target = (location.state as { scrollTo?: string } | null)?.scrollTo
      || (location.hash ? location.hash.slice(1) : null);
    if (!target) return;
    let attempts = 0;
    const tick = () => {
      const el = document.getElementById(target);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else if (attempts++ < 40) {
        setTimeout(tick, 100);
      }
    };
    tick();
  }, [location]);

  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Fitawrari FX — Forex Mentorship & Trading Education"
        description="Learn Forex trading with Fitawrari FX. Private mentorship, technical analysis, and SK System coaching for students across Ethiopia."
        path="/"
      />
      <Navbar />
      <Hero />

      <Suspense fallback={<SectionLoader />}>
        <MentorSection />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <YouTubeSection />
      </Suspense>
      <Suspense fallback={null}>
        <CTAStrip />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <Curriculum />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <Pricing />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <CertificateClaim />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <Testimonials />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <Partners />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <Footer />
      </Suspense>
      <Suspense fallback={null}>
        <StickyMobileCTA />
      </Suspense>
    </div>
  );
};

export default Index;
